import React from "react";
import { Sparkles, ArrowRight } from "lucide-react";

export const FinalCta = ({ onScrollDemo }) => {
  return (
    <section className="relative py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="relative overflow-hidden rounded-3xl p-8 md:p-14 text-center glass-strong">
          <div
            className="absolute -top-20 left-1/2 -translate-x-1/2 h-72 w-[110%] blur-3xl opacity-50 pointer-events-none"
            style={{
              background:
                "radial-gradient(ellipse, rgba(168,255,0,0.25), rgba(0,239,255,0.2) 40%, transparent 70%)",
            }}
          />
          <div className="relative">
            <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
              Klaar om te starten?
            </span>
            <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
              Wilt u zien hoe een{" "}
              <span className="text-gradient-neon">AI-chatbot</span> voor uw bedrijf
              kan werken?
            </h2>
            <p className="mt-5 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed max-w-2xl mx-auto">
              Vraag gratis een demo aan en ontdek hoe uw website bezoekers kan helpen,
              vragen kan beantwoorden en aanvragen kan verzamelen — ook buiten
              kantooruren.
            </p>

            <button
              data-testid="final-cta-btn"
              onClick={onScrollDemo}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-gradient-neon px-7 py-4 text-[15px] font-semibold text-[#0A0A1A] transition-transform duration-200 hover:scale-[1.03] glow-cyan"
            >
              <Sparkles className="h-4 w-4" />
              Vraag gratis demo aan
              <ArrowRight className="h-4 w-4" />
            </button>
            <p className="mt-4 text-xs text-[#A7A7A7]">
              Geen verplichting. Eerst zien, daarna beslissen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
